import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/easm-settings')({
  beforeLoad: () => getTitleContextSlice('EASM-Settings'),
});
